module.exports = __webpack_public_path__ + "static/media/menu-vaults-icon-hover.7849b830.svg";